/*
  Pins the "Also In Bags" tab bar to the top of the viewport (just below the
  sticky header) while the product grid below it is in view, then releases it
  back into normal flow once the grid has scrolled past - so it doesn't stay
  pinned over unrelated content further down the page (How To Choose, Why La
  Ellore, etc).

  CSS position:sticky can't do this on its own here: the tab bar and the
  product grid are separate top-level sections, each wrapped in its own
  Shopify section div, so the tab bar's containing block for sticky purposes
  is just its own (short) wrapper - there's no taller shared ancestor to give
  it room to stick against. This measures scroll position directly instead.
*/
(function () {
  const tabs = document.querySelector('.collection-tabs');
  const wrapper = document.querySelector('.collection-wrapper');
  if (!tabs || !wrapper) return;

  const spacer = document.createElement('div');
  spacer.className = 'collection-tabs-sticky-spacer';
  spacer.hidden = true;
  tabs.insertAdjacentElement('afterend', spacer);

  let pinned = false;
  let ticking = false;
  let pinnedBarHeight = 0;

  function headerHeight() {
    // --header-height is declared on `body` (see sections/header.liquid),
    // not on :root/<html> - custom properties only inherit downward from
    // ancestor to descendant, so reading it from document.documentElement
    // (body's own parent) always returned an empty value here, silently
    // falling back to 0. Read it from body, where it's actually set.
    const raw = getComputedStyle(document.body).getPropertyValue('--header-height');
    const value = parseFloat(raw);
    return Number.isFinite(value) ? value : 0;
  }

  function stickyGap() {
    const raw = getComputedStyle(tabs).getPropertyValue('--collection-tabs-sticky-gap');
    const value = parseFloat(raw);
    return Number.isFinite(value) ? value : 0;
  }

  function update() {
    ticking = false;

    const gap = stickyGap();
    const offset = headerHeight() + gap;
    const reference = pinned ? spacer : tabs;
    const referenceRect = reference.getBoundingClientRect();
    const wrapperBottom = wrapper.getBoundingClientRect().bottom;
    const barHeight = pinned ? pinnedBarHeight : tabs.getBoundingClientRect().height;

    const shouldPin = referenceRect.top <= offset && wrapperBottom > offset + barHeight;

    if (shouldPin && !pinned) {
      // Measure height AFTER adding .is-pinned, not before: the pinned
      // state is shorter on mobile (stacked label hidden, tighter padding),
      // so measuring first would reserve a taller spacer than the pinned
      // bar actually needs, leaving a gap above the product grid.
      tabs.style.setProperty('--collection-tabs-pin-top', `${offset}px`);
      tabs.classList.add('is-pinned');
      pinnedBarHeight = tabs.getBoundingClientRect().height;
      // The spacer must reserve the gap too, not just the bar's own height -
      // otherwise the page's underlying content (the product grid) is only
      // pushed down by the bar's height, leaving a `gap`-tall strip between
      // the header and the pinned bar where the grid's own top edge (its
      // card images) scrolls up into view and shows through.
      spacer.style.height = `${gap + pinnedBarHeight}px`;
      spacer.hidden = false;
      pinned = true;
    } else if (!shouldPin && pinned) {
      tabs.classList.remove('is-pinned');
      spacer.hidden = true;
      pinned = false;
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  // On desktop (>= 990px) Horizon makes .page-wrapper the actual scrolling
  // container (overflow-y:auto), not the window - window scroll events never
  // fire there at all. On mobile .page-wrapper doesn't scroll internally, so
  // window is the one that fires. Listening on both covers both cases; a
  // listener on an element that never scrolls is simply never called.
  const pageWrapper = document.querySelector('.page-wrapper');

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  if (pageWrapper) {
    pageWrapper.addEventListener('scroll', onScroll, { passive: true });
  }
  update();
})();
